"use client";

import React, { useEffect, useState } from "react";

import { Card } from "./ui/card";
import { Tabs, TabsList, TabsTrigger } from "./ui/tabs";
import { useToast } from "../hooks/use-toast";
import { useAuth } from "../context/AuthContext";
import SendForex from "./SendForex";
import ReceiveForex from "./ReceiveForex";
import SendConfirmationForex from "./SendConfirmationForex";
import { verify2FA } from "../services/digitalWalletService";
import SendForexComplete from "./SendForexComplete";
import AuthTwoFA from "./AuthTwoFA";
import { currencies } from "../data/mockTradeRates";
import CurrencyFormatter from "../utils/currencyFormatter";
import { useFeatureAccess } from "./FeatureGate";
import { FeatureGate } from "./FeatureGate";
const SendReceiveForex = ({
  assetToSelect,
  tab,
  tradingAssets,
  tradingNets,
  childTab,
}) => {
  const { flags: featureFlags, isLoading: isLoadingFlags } = useFeatureAccess(
    "mainFeatures",
    ["withdrawForex", "depositForex"]
  );
  const isSendEnabled = featureFlags?.withdrawForex;
  const isReceiveEnabled = featureFlags?.depositForex;

  const [selectedTab, setSelectedTab] = useState(null);
  const [selectedAsset, setSelectedAsset] = useState(null);
  const [amount, setAmount] = useState(null);
  const [zarAmount, setZarAmount] = useState(null);
  const [destinationAddress, setDestinationAddress] = useState("");
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [selectedNetwork, setSelectedNetwork] = useState([]);
  const [currency, setCurrency] = useState(null);
  const [currentRate, setCurrentRate] = useState(null);
  const [showAuth, setShowAuth] = useState(false);
  const [hasBeenSetUp, setHasBeenSetUp] = useState(false);
  const [amountFlag, setAmountFlag] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [isVerifying, setIsVerifying] = useState(false);
  const [quoteData, setQuoteData] = useState(null);
  const [isEnabled, setIsEnabled] = useState(false);

  const { toast } = useToast();
  const { settings, updateSettings } = useAuth();

  useEffect(() => {
    setIsEnabled(settings?.security?.twoFactorAuth?.enabled);
  }, [settings]);

  // Set default tab based on feature flags
  useEffect(() => {
    if (isLoadingFlags) return;
    if (selectedTab !== null) return;
    if (isSendEnabled) {
      setSelectedTab("send");
    } else if (isReceiveEnabled) {
      setSelectedTab("receive");
    }
  }, [isSendEnabled, isReceiveEnabled, selectedTab, isLoadingFlags]);

  useEffect(() => {
    if (settings) {
      const localCurrency = settings?.preferences?.localCurrency || "ZAR";
      setCurrency(localCurrency);
    }
    if (!settings) {
      const localCurrency = "ZAR";
      setCurrency(localCurrency);
    }
  }, [settings]);

  useEffect(() => {
    const validTabs = ["send", "receive"];
    if (!tab) return;
    if (validTabs.includes(tab)) {
      setSelectedTab(tab);
    }
  }, [tab]);
  useEffect(() => {
    const validTabs = ["send", "receive"];
    if (!childTab) return;
    if (validTabs.includes(childTab)) {
      setSelectedTab(childTab);
    }
  }, [childTab]);

  const handleTabChange = (value) => {
    setSelectedTab(value);
  };

  const handleSelectedAsset = (asset, rate) => {
    setSelectedAsset(asset);
    setCurrentRate(rate);
  };
  const formatter = new CurrencyFormatter();
  const sendQuoteArray = {
    amount: amount,
    cryptoAsset: selectedAsset?.asset,
    chain: selectedNetwork?._id,
  };

  const handleQuote = async () => {
    try {
      // const totalAmount =
      //   parseFloat(zarAmount) + parseFloat(selectedAsset?.withdrawalFee);
      const totalAmount = parseFloat(zarAmount);
      const result = {
        amountReceived: sendQuoteArray?.amount,
        amountReceivedFormatted: formatter.format(
          sendQuoteArray?.amount,
          sendQuoteArray?.cryptoAsset?.toUpperCase()
        ),
        totalAmount: totalAmount,
        totalAmountFormatted: formatter.format(totalAmount, "ZAR"),
        // withdrawalFee: selectedAsset?.withdrawalFee,
        // withdrawalFeeFormatted: formatter.format(
        //   selectedAsset?.withdrawalFee,
        //   "ZAR"
        // ),
        withdrawalFee: 0,
        withdrawalFeeFormatted: formatter.format(0, "ZAR"),
      };
      const resData = result;
      if (result) {
        const totalWithFee = resData?.totalAmount;
        if (selectedAsset?.availableAmount < totalWithFee) {
          setAmountFlag(true);
          setIsSending(false);
        }

        if (selectedAsset?.availableAmount >= totalWithFee) {
          setAmountFlag(false);
          handleContinue(resData);
        }
      }
    } catch (error) {
      toast({
        description: `${error}`,
        variant: "eighty",
      });
    }
  };
  const handleChangeAmount = (amount, zar) => {
    setAmount(amount);
    setZarAmount(zar);
  };

  const handleConfirm = async () => {
    try {
      const result = "Sent";
      if (result === "Sent") {
        setShowAuth(false);
        setShowConfirmation(false);
        setShowSuccess(true);
      }
    } catch (error) {
      toast({
        description: `${error}`,
        variant: "eighty",
      });
      setShowAuth(true);
      setShowConfirmation(true);
      setShowSuccess(false);
    }
  };

  const handleContinue = (quoteData) => {
    setQuoteData(quoteData);
    setShowConfirmation(true);
    // setShowAuth(true);
    // setShowSuccess(false);
  };

  const twoFactor = () => {
    if (hasBeenSetUp) {
      handleConfirm();
    }
    if (!hasBeenSetUp) {
      setShowConfirmation(false);
      setShowAuth(true);
    }
  };

  const handleVerify = async (token) => {
    try {
      const twoFAdata = {
        token: token,
      };

      const verifiedTwoFA = await verify2FA(twoFAdata);
      if (verifiedTwoFA) {
        updateSettings(verifiedTwoFA);
        toast({
          description: `2FA ${isEnabled ? "verified" : "enabled"} Successfully`,
          variant: "eighty",
        });
        handleConfirm();
      }
    } catch (error) {
      toast({
        description: `${error.message}`,
        variant: "eighty",
      });
      setIsVerifying(false);
    }
  };
  const handleSelectedChain = (chain) => {
    setSelectedNetwork(chain);
  };
  const handleSetup = () => {
    setHasBeenSetUp(true);
  };
  const handleBackfromTwoFA = () => {
    setShowAuth(false);
    setShowConfirmation(true);
  };
  const handleCancel = () => {
    setShowConfirmation(false);
    setIsSending(false);
  };
  return (
    <>
      {!showConfirmation && !showSuccess && !showAuth && (
        <Card className="w-full p-8 shadow-lg bg-white rounded-2xl">
          {(isSendEnabled || isReceiveEnabled) && (
            <Tabs onValueChange={handleTabChange} className="mb-8 ml-5 mr-12">
              <TabsList
                className={`grid ${isSendEnabled && isReceiveEnabled ? "grid-cols-2" : "grid-cols-1"} rounded-full bg-gray-100 h-100`}
              >
                <FeatureGate flag="withdrawForex">
                  <TabsTrigger
                    value="send"
                    className={`py-3 text-lg font-semibold rounded-full transition-colors ${
                      selectedTab === "send"
                        ? "bg-purple-900 text-white"
                        : "text-gray-600"
                    }`}
                  >
                    Send
                  </TabsTrigger>
                </FeatureGate>
                <FeatureGate flag="depositForex">
                  <TabsTrigger
                    value="receive"
                    className={`py-3 text-lg font-semibold rounded-full transition-colors ${
                      selectedTab === "receive"
                        ? "bg-purple-900 text-white"
                        : "text-gray-600"
                    }`}
                  >
                    Receive
                  </TabsTrigger>
                </FeatureGate>
              </TabsList>
            </Tabs>
          )}

          {selectedTab === "send" && !showConfirmation ? (
            <SendForex
              hotActionAsset={tab === "send" ? assetToSelect : null}
              onChangeAmount={handleChangeAmount}
              onSelectAsset={handleSelectedAsset}
              onSelectChain={handleSelectedChain}
              currencies={currencies}
              selectedAsset={selectedAsset}
              setSelectedAsset={setSelectedAsset}
              setTagNumber={null}
              destinationAddress={destinationAddress}
              setDestinationAddress={setDestinationAddress}
              onContinue={handleContinue}
              loadingOnContinue={false}
              onhandleQuote={handleQuote}
              setAmountFlag={setAmountFlag}
              amountFlag={amountFlag}
              parentAmount={amount}
              setAmount={setAmount}
              isSending={isSending}
              setIsSending={setIsSending}
              currentRate={currentRate}
              selectedNetwork={selectedNetwork}
              zarAmount={zarAmount}
            />
          ) : (
            <ReceiveForex
              hotActionAsset={tab === "receive" ? assetToSelect : null}
              selectedAsset={selectedAsset}
              setSelectedAsset={setSelectedAsset}
              tradingNets={tradingNets}
              tradingAssets={tradingAssets}
            />
          )}
        </Card>
      )}

      {showConfirmation && !showSuccess && (
        <SendConfirmationForex
          quoteData={quoteData}
          asset={selectedAsset}
          zar={zarAmount}
          amount={amount}
          currency={currency}
          currentRate={currentRate}
          destinationAddress={destinationAddress}
          onCancel={handleCancel}
          onConfirm={twoFactor}
          setUp={handleSetup}
        />
      )}
      {showAuth === true && !showSuccess && !showConfirmation && (
        <AuthTwoFA
          onVerify={handleVerify}
          onBack={handleBackfromTwoFA}
          isVerifying={isVerifying}
          setIsVerifying={setIsVerifying}
        />
      )}
      {showSuccess === true && !showConfirmation && !showAuth && (
        <SendForexComplete
          assetName={selectedAsset?.asset || "ETH"}
          onDone={() => {
            setShowSuccess(false);
            setDestinationAddress(null);
            window.location.reload();
          }}
        />
      )}
    </>
  );
};

export default SendReceiveForex;
